import {INSTITUT_ROUTES as institutRoutes, MARQUES_ROUTES as marquesRoutes} from "~/api/routes";
import {generateOptions, setLoggedUser} from "~/helpers";
import Vue from 'vue';

export const state = () => ({
  marques: [],
  details: [],
  close:false,
  isRequesting:false,
  selectedMarque: null,
});

export const getters = {
  optionsMarques: (state) => {
    try {
      if (state.marques.length)
        return generateOptions(state.marques, 'nom', 'marque_id');
      return [];
    } catch (e) {
      console.log(e)
    }
  },
  marques: (state) => {
    if (state.marques)
      return state.marques;
    return [];
  },
};
export const mutations = {
  MARQUES_SUCCES(state, params){
    state.marques = params;
  },
  IS_REQUESTING(state, params){
    state.isRequesting = params;
  },
  DELETE_MARQUE(state, id){
    state.marques = state.marques.filter(m => m.marque_id != id);
  },
  SELECTED_MARQUE(state, params){
    state.selectedMarque = params;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  ADD_MARQUE(state, params){
    try {
      state.marques.push(params);
    }catch (err)
    {

    }
  },
  PUBLIE_MARQUE(state, params){
    state.marques = state.marques.map(m =>{
      if (m.marque_id === params.marque_id)
        m.publier = params.publier;
      return m;
    });
  },
  EPINGLER_MARQUE(state, params){
    state.marques = state.marques.map(m =>{
      if (m.marque_id === params.marque_id)
        m.epingler = params.epingler;
      return m;
    });
  },
  UPDATE_MARQUE(state, elem){
    state.marques = state.marques.map(m =>{
      if (m.marque_id === elem.marque_id)
      {
        elem.delivery_modes = m.delivery_modes;
        return elem;
      }

      return m;
    });
  }
};

export const actions = {
  createMarque({ commit }, params) {
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    return new Promise((resolve, reject) => {
      this.$api.request(marquesRoutes.create, {}, params)
        .then(response => {
          commit('CLOSE_MODAL',true);
          commit('ADD_MARQUE', response.payload);
          resolve({message: 'Marque créée avec succès', type: 'success'});
        })
        .catch((error) => {
          commit('CLOSE_MODAL',false);
          const {response: {data: {_response}}} = error;
          if(_response && _response.code == 'G406_02') {
            reject();
          }
          reject({message: 'une erreur s\'est produite, veuillez réessayer', type: 'error'});
        })
        .finally(() => {
          commit('IS_REQUESTING',false);
        });
    });
  },
  updateMarque({ commit }, params) {
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    return new Promise((resolve, reject) => {
      this.$api.request(marquesRoutes.update, {id: params.id}, params.formData)
        .then(response => {
          commit('CLOSE_MODAL', true);
          commit('UPDATE_MARQUE', response.payload);
          resolve(response.payload);
        })
        .catch(error => {
          commit('CLOSE_MODAL', false);
          reject({message: 'une erreur s\'est produite, veuillez réessayer', type: 'error'});
        })
        .finally(() => {
          commit('IS_REQUESTING', false);
        });
    });
  },
  getMarques({ commit }) {
    commit('IS_REQUESTING',true);
    return new Promise((resolve, reject) => {
    this.$api.request(marquesRoutes.list)
      .then(response => {
        commit('MARQUES_SUCCES', response.payload);
        resolve();
      })
      .catch(error => {
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
      });});
  },
  deleteMarque({commit}, params){
    commit('IS_REQUESTING',true);
    return new Promise((resolve, reject) => {
      this.$api.request(marquesRoutes.delete, {'id': params.marque_id})
        .then(response => {
          commit('DELETE_MARQUE', params.marque_id);
          Vue.$toast.success('la marque est supprimée avec succès');
        })
        .catch(error => {
          if(error?.response?.data?._response?.code === '500')
            Vue.$toast.error('vous ne pouvez pas supprimer une maque associée à des produits');
          else
            Vue.$toast.error('une erreur s\'est produite, veuillez réessayer');
        })
        .finally(() => {
          commit('IS_REQUESTING', false);
        });
    });
  },
  setSelectedMarque({commit}, params) {
    commit('SELECTED_MARQUE', params);
  },
  publier({commit}, params) {
    commit('IS_REQUESTING',true)
    return new Promise((resolve, reject) => {
      this.$api.request(marquesRoutes.publie, {'id': params.marque_id})
        .then(response => {
          commit('PUBLIE_MARQUE', response.payload);
          resolve();
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit('IS_REQUESTING', false);
        });
    });
  },
  epingler({commit}, params) {
    commit('IS_REQUESTING',true)
    return new Promise((resolve, reject) => {
      this.$api.request(marquesRoutes.epingle, {'id': params.marque_id})
        .then(response => {
          commit('EPINGLER_MARQUE', response.payload);
          resolve();
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit('IS_REQUESTING', false);
        });
    });
  }
};
